import { useUpcomingPeriods as _useUpcomingPeriods } from '@griply/hooks';
import { Task } from '@griply/types';
import { useToday } from 'shared/contexts/today';

import { useData } from '../../use-data';

export const useUpcomingPeriods = (task: Task) => {
  const today = useToday();
  const { weekStartsOn } = useData();
  return _useUpcomingPeriods(task, { today, weekStartsOn });
};
